/**
 * 功能：业务错误处理
 * 参数：
 *  error:
 *  {
 *    showInMessage: 显示在Message窗口（默认：true)
 *  }
 */
// import store from '@/store'
import { Message, MessageBox } from 'element-ui';

export function handleError(response, config) {
  // 错误处理
  switch (response.data.resultCode) {
    // 未登录/登录超时
    case '910':
      processLoginError();
      break;
    // 登录禁用
    case 'LOGN_914':
      processLoginValid();
      break;
    default:
      processDefault(response, config);
      break
  }
}

// 默认
function processDefault(response, config) {
  // 获取参数
  let showInMessage = ((config._extend_config && config._extend_config.showInMessage != undefined) ? config.showInMessage : true);
  var msg = response.data.message;
  if(!msg){
    msg = response.data.repMsg;
  }
  // // 在Message中提示错误
  if (showInMessage == true) {
    Message({
      message: msg,
      type: 'error'
    });
  }
}

// 未登录/登录超时
let loginErrorWindow = null;
function processLoginError() {
  // 不再重复打开弹窗
  if (loginErrorWindow)
    return;
  // 打开弹窗
  loginErrorWindow = MessageBox.confirm('用户未登录, 是否重新登录？', '提示',
    {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning',
      confirmButtonClass: 'standard-btn',
      cancelButtonClass: 'simple-btn'
    })
    .then(() => {
      let code = localStorage.getItem('urlParmasCode') // 渠道链接用户
      let host = window.location.origin
      // store.dispatch('global/user/resetToken').then(() => {
      //   if(code && code != 'null' ){
      //     localStorage.setItem('urlParmasCode', 'null');
      //     location.replace(host+'/login?code='+code);
      //   }else{
      //     location.reload();
      //   }
      // })
    })
    .finally(() => {
      loginErrorWindow = null;
    });
}

// 登录禁用
function processLoginValid() {
  MessageBox.alert('<div><p>您的账号已被禁用</p><p>请联系管理员修改您的账号状态</p></div>', '提示', {
    dangerouslyUseHTMLString: true,
    confirmButtonText: '我知道了',
    showCancelButton: false,
    center: true,
    confirmButtonClass: 'standard-btn',
    closeOnClickModal: true,
    closeOnPressEscape: true
  })
}

